/**
 * Print file resolution
 *
 * The one place that turns physical millimetres into print file pixels and
 * back. Live print data, the QC check and the frozen print specification
 * all call these two functions; the dpi is a parameter so that a second
 * resolution never needs a second copy of the formula (R15, R16).
 */

/** Millimetres in one inch. */
export const MM_PER_INCH = 25.4;

/** Resolution of the print files production receives. */
export const PRINT_DPI = 300;

/**
 * Print file pixels of a physical length, rounded to whole pixels.
 *
 * @example pxFromMm(120.5) === 1423
 * @example pxFromMm(120.5, 150) === 712
 */
export function pxFromMm(mm: number, dpi: number = PRINT_DPI): number {
  return Math.round((mm / MM_PER_INCH) * dpi);
}

/**
 * Physical length of a print file pixel count. Not rounded: the caller
 * decides which precision it stores or compares at.
 *
 * @example mmFromPx(1181) ≈ 100
 */
export function mmFromPx(px: number, dpi: number = PRINT_DPI): number {
  return (px / dpi) * MM_PER_INCH;
}
